import React, { useEffect, useRef, useState } from 'react';
import {
  VARIABLE_TYPE_ARRAY,
  VARIABLE_TYPE_NUMBER,
  VARIABLE_TYPE_STRING,
} from '../../../../utils/variableScope';

/**
 * "+ Add Variable" control with a small type menu (text / number / array).
 */
const AddVariableMenu = ({ onAdd }) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onPointerDown = (e) => {
      if (rootRef.current?.contains(e.target)) return;
      setOpen(false);
    };
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  const choose = (type) => {
    setOpen(false);
    onAdd?.(type);
  };

  return (
    <div
      ref={rootRef}
      className={`variables-panel__add${open ? ' is-open' : ''}`}
    >
      <button
        type="button"
        className="variables-panel__add-btn"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        + Add Variable
      </button>
      {open && (
        <div className="variables-panel__add-menu" role="menu">
          <button
            type="button"
            role="menuitem"
            className="variables-panel__add-menu-item"
            onClick={() => choose(VARIABLE_TYPE_STRING)}
          >
            <span className="variables-panel__add-menu-label">Text</span>
            <span className="variables-panel__add-menu-hint">
              One value — {'{{name}}'}
            </span>
          </button>
          <button
            type="button"
            role="menuitem"
            className="variables-panel__add-menu-item"
            onClick={() => choose(VARIABLE_TYPE_NUMBER)}
          >
            <span className="variables-panel__add-menu-label">Number</span>
            <span className="variables-panel__add-menu-hint">
              Digits only — {'{{name}}'}
            </span>
          </button>
          <button
            type="button"
            role="menuitem"
            className="variables-panel__add-menu-item"
            onClick={() => choose(VARIABLE_TYPE_ARRAY)}
          >
            <span className="variables-panel__add-menu-label">Array</span>
            <span className="variables-panel__add-menu-hint">
              Multiple values — {'{{name[1]}}'}
            </span>
          </button>
        </div>
      )}
    </div>
  );
};

export default AddVariableMenu;
